import { ERP } from '../_base/endpoint';
import axios from 'axios';

class tipoPersonaService {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/tipo-persona`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new tipoPersonaService();